import { fmtAmt, fmtUsd, fmtPct, fmtPrice } from "../../lib/format";

const Bar = ({ pct, color }) => (
  <div className="h-1.5 w-full bg-ink rounded-sm overflow-hidden">
    <div className="h-full transition-[width] duration-500" style={{ width: `${Math.max(2, Math.min(100, pct))}%`, background: color }} />
  </div>
);

export const SlippageSaved = ({ s, symbol, amount, compact = false }) => {
  if (!s) return null;
  const stock = s.stock || "NVDA";
  const max = Math.max(s.escrow_proceeds_usd, s.pool_proceeds_usd) || 1;
  const positive = s.saved_usd >= 0;
  return (
    <div className="relative overflow-hidden rounded-md border border-violet/40 bg-[linear-gradient(180deg,rgba(192,38,245,0.12),rgba(12,12,15,0.6))]" data-testid="slippage-calculator-container">
      <div className="px-4 pt-3 pb-2 flex items-start justify-between gap-4">
        <div>
          <div className="eyebrow text-violet-300" data-testid="calc-title">{stock} impact saved</div>
          <div className={`mono font-semibold tracking-tight mt-1 ${compact ? "text-2xl" : "text-3xl"} ${positive ? "text-white" : "text-neg"}`} data-testid="calc-savings-metric">
            {positive ? "+" : "−"}{fmtUsd(Math.abs(s.saved_usd))}
          </div>
          <div className="mono text-xs text-fog mt-0.5">{fmtPct(Math.abs(s.saved_pct_of_notional), 1)} of notional saved vs the public pool</div>
        </div>
        <div className="text-right">
          <div className="eyebrow">Pool impact avoided</div>
          <div className="mono text-xl font-semibold text-neg mt-1" data-testid="calc-impact-metric">−{s.impact_pct.toFixed(2)}%</div>
          <div className="mono text-[11px] text-fog">{fmtAmt(amount)} {symbol} = {s.pool_share_pct.toFixed(1)}% of pool depth</div>
        </div>
      </div>

      <div className="px-4 pb-3 space-y-2.5">
        <div>
          <div className="flex justify-between mono text-[11px] mb-1"><span className="text-slate-400">Sell into {symbol}/{stock} pool (Uniswap v4)</span><span className="text-slate-200" data-testid="calc-pool-proceeds">{fmtUsd(s.pool_proceeds_usd)}</span></div>
          <Bar pct={(s.pool_proceeds_usd / max) * 100} color="#F43F5E" />
          <div className="mono text-[10px] text-fog mt-1">avg fill {fmtPrice(s.effective_price_usd)}/M · pool price after: {fmtPrice(s.post_trade_price_usd)} ({fmtPct(-s.price_drop_pct, 1)}) — arbitraged across every {stock} pool</div>
        </div>
        <div>
          <div className="flex justify-between mono text-[11px] mb-1"><span className="text-slate-400">Settle via Cross escrow (flat, off-market)</span><span className="text-white font-medium" data-testid="calc-escrow-proceeds">{fmtUsd(s.escrow_proceeds_usd)}</span></div>
          <Bar pct={(s.escrow_proceeds_usd / max) * 100} color="#C026F5" />
          <div className="mono text-[10px] text-fog mt-1">fixed {fmtPrice(s.escrow_proceeds_usd / amount)}/M · pool untouched, {stock} peg unmoved: {fmtPrice(s.pool_price_usd)}</div>
        </div>
        {!positive && <div className="text-[11px] text-neg" data-testid="calc-negative-warning">Offered discount exceeds the pool's own impact at this size. The seller would net more selling into the pool. Raise the price.</div>}
      </div>
    </div>
  );
};
